import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VerificationDataRequirements } from 'ng-voxloud';
import { DID_STATUS, DID, VerificationData } from 'voxloud-types/dist/models';
import { VerificationDataService } from 'src/app/domains/dids/services';

export enum OPTION_TYPE {
  NEW = 'new',
  CLONE = 'clone',
  NONE = 'none'
};

export interface VerificationDataSelection {
  value: VerificationData,
  isValid: boolean,
  type: string;
  selectedOpt: { type: OPTION_TYPE, did: DID }
};

@Component({
  selector: 'gdp-verification-data-selection-form',
  templateUrl: './verification-data-selection-form.component.html',
  styleUrls: ['./verification-data-selection-form.component.scss']
})
export class VerificationDataSelectionFormComponent implements OnInit {
  @Input() language: string;
  @Input() country: string;
  @Input() dids: DID[];
  @Input() requirements: VerificationDataRequirements;
  @Input() allowNoVD: boolean = false;
  @Input() isVerticalVDTable: boolean = false;
  public loading: boolean = false;
  public selectedOption: { type: OPTION_TYPE, did: DID } = { type: OPTION_TYPE.NEW, did: null };
  public verificationData: VerificationData;
  public isValid: boolean = true;
  public DID_STATUS = DID_STATUS;
  public OPTION_TYPE = OPTION_TYPE;
  public showVDDataErrorMessage: boolean = false;
  @Output() onEmitVerificationData: EventEmitter<{ value: VerificationData, isValid: boolean, selectedOpt: { type: OPTION_TYPE, did: DID } }> = new EventEmitter();

  constructor(
    private verificationDataService: VerificationDataService
  ) { }

  ngOnInit(): void { }

  onSelectDid(type: OPTION_TYPE, did: DID): void {
    this.selectedOption = { type: type, did: did };
    if (this.selectedOption.type === OPTION_TYPE.CLONE) {
      this.getVerificationData(this.selectedOption.did);
    } else if (this.selectedOption.type === OPTION_TYPE.NONE) {
      this.onEmitVerificationData.emit({ value: null, isValid: true, selectedOpt: this.selectedOption });
    }
  }

  getVerificationData(did: DID): void {
    this.loading = true;
    this.verificationDataService.getVerificationDataById(did.verification_data_id)
      .subscribe((res: VerificationData) => {
        this.verificationData = res;
        this.onEmitVerificationData.emit({ value: this.verificationData, isValid: true, selectedOpt: this.selectedOption });
        this.loading = false;
        this.showVDDataErrorMessage = false;
      }, () => {
        this.showVDDataErrorMessage = true;
        this.onEmitVerificationData.emit({ value: null, isValid: false, selectedOpt: this.selectedOption });
        this.loading = false;
      }
      )
  }

  onVerificationDataChange(event): void {
    this.verificationData = { ...event.value, type: event.type };
    this.isValid = event.isValid;
    this.onEmitVerificationData.emit({ ...event, selectedOpt: this.selectedOption });
  }
}
